/* tslint:disable:max-line-length */
import { TreoNavigationItem } from '@treo/components/navigation';

export const defaultNavigation: TreoNavigationItem[] = [
    {
        id: 'futebol',
        title: 'Futebol',
        type: 'basic',
        link: '/jogos',
        icon: 'mat_outline:sports_soccer'
    },
    {
        id: 'usuarios',
        title: 'Usuários',
        type: 'collapsable',
        icon: 'mat_outline:account_box',
        children: [
            {
                id: 'gerentes',
                title: 'Gerentes',
                type: 'basic',
                link: '/gerentes'
            },
            {
                id: 'vendedores',
                title: 'Vendedores',
                type: 'basic',
                link: '/vendedores'
            }
        ]

    },
    {
        id: 'bilhetes',
        title: 'Bilhetes',
        type: 'basic',
        link: '/bilhetes',
        icon: 'mat_outline:receipt'
    },
    {
        id: 'caixa',
        title: 'Caixa',
        type: 'basic',
        link: '/caixa',
        icon: 'mat_outline:account_balance_wallet'
    },
    {
        id: 'financeiro',
        title: 'Financeiro',
        type: 'basic',
        link: '/financeiro',
        icon: 'mat_outline:attach_money'
    },
    {
        id: 'mapa',
        title: 'Mapa de Apostas',
        type: 'basic',
        link: '/mapa',
        icon: 'mat_outline:map'
    },
    {
        id: 'riscos',
        title: 'Gerenciar Riscos',
        type: 'basic',
        link: '/riscos',
        icon: 'mat_outline:assignment_late'
    },
    {
        id: 'cotacoes',
        title: 'Gerenciar Cotações',
        type: 'basic',
        link: '/cotacoes',
        icon: 'mat_outline:swap_vert'
    },
    {
        id: 'configuracoes',
        title: 'Configurações',
        type: 'basic',
        link: '/configuracoes',
        icon: 'mat_outline:settings'
    },
    {
        id: '',
        title: '',
        type: 'group',
        link: '',
        icon: ''
    },
    {
        id: 'regras',
        title: 'Regras',
        type: 'basic',
        link: '/regras',
        icon: 'mat_outline:help_outline'
    }
];
export const compactNavigation: TreoNavigationItem[] = [
    {
        id: 'starter',
        title: 'Starter',
        type: 'aside',
        icon: 'apps',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const futuristicNavigation: TreoNavigationItem[] = [
    {
        id: 'starter.example',
        title: 'Example component',
        type: 'basic',
        icon: 'heroicons:chart-pie',
        link: '/example'
    },
    {
        id: 'starter.dummy.1',
        title: 'Dummy menu item #1',
        icon: 'heroicons:calendar',
        type: 'basic'
    },
    {
        id: 'starter.dummy.2',
        title: 'Dummy menu item #1',
        icon: 'heroicons:user-group',
        type: 'basic'
    }
];
export const horizontalNavigation: TreoNavigationItem[] = [
    {
        id: 'futebol',
        title: 'Futebol',
        type: 'basic',
        link: '/jogos',
        icon: 'mat_outline:sports_soccer'
    },
    {
        id: 'usuarios',
        title: 'Usuários',
        type: 'collapsable',
        icon: 'mat_outline:account_box',
        children: [
            {
                id: 'gerentes',
                title: 'Gerentes',
                type: 'basic',
                link: '/gerentes'
            },
            {
                id: 'vendedores',
                title: 'Vendedores',
                type: 'basic',
                link: '/vendedores'
            }
        ]

    },
    {
        id: 'bilhetes',
        title: 'Bilhetes',
        type: 'basic',
        link: '/bilhetes',
        icon: 'mat_outline:receipt'
    },
    {
        id: 'caixa',
        title: 'Caixa',
        type: 'basic',
        link: '/caixa',
        icon: 'mat_outline:account_balance_wallet'
    },
    {
        id: 'financeiro',
        title: 'Financeiro',
        type: 'basic',
        link: '/financeiro',
        icon: 'mat_outline:attach_money'
    },
    {
        id: 'mapa',
        title: 'Mapa de Apostas',
        type: 'basic',
        link: '/mapa',
        icon: 'mat_outline:map'
    },
    {
        id: 'riscos',
        title: 'Gerenciar Riscos',
        type: 'basic',
        link: '/riscos',
        icon: 'mat_outline:assignment_late'
    },
    {
        id: 'cotacoes',
        title: 'Gerenciar Cotações',
        type: 'basic',
        link: '/cotacoes',
        icon: 'mat_outline:swap_vert'
    },
    {
        id: 'configuracoes',
        title: 'Configurações',
        type: 'basic',
        link: '/configuracoes',
        icon: 'mat_outline:settings'
    },
    {
        id: '',
        title: '',
        type: 'group',
        link: '',
        icon: ''
    },
    {
        id: 'regras',
        title: 'Regras',
        type: 'basic',
        link: '/regras',
        icon: 'mat_outline:help_outline'
    }
];
